import { CANONICAL_SUCCESS_MESSAGES } from "./types";

export interface IdentitySuccessProps {
  message: keyof typeof CANONICAL_SUCCESS_MESSAGES | string;
}

export function IdentitySuccess({ message }: IdentitySuccessProps) {
  const text =
    message in CANONICAL_SUCCESS_MESSAGES
      ? CANONICAL_SUCCESS_MESSAGES[message as keyof typeof CANONICAL_SUCCESS_MESSAGES]
      : message;
  return (
    <p className="sc-identity-success" role="status" aria-live="polite">
      {text}
    </p>
  );
}
